module.exports = __webpack_public_path__ + "static/media/raidguild__logo.e93c42f0.png";